import React, { useEffect, useState } from "react";
import Header from "../../components/Header";
import "./index.scss";
import TopComponent from "./TopComponent";
import FeaturesComponent from "./FeaturesComponent";
// import ScreenshotSlider from "./ScreenshotSlider";
import ContactForm from "./ContactForm";
import Footer from "../../components/Footer";
import BetaTesterModal from "./BetaTesterModal";
import { useLocation } from "react-router-dom";
// import DailySchedule from "./DailySchedule";

const Home = () => {
  const [showScrollTop, setShowScrollTop] = useState(false);
  const [showBetaModal, setShowBetaModal] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setShowScrollTop(window.scrollY > 250);
    };

    window.addEventListener("scroll", handleScroll);

    // Check if modal was shown today
    const today = new Date().toLocaleDateString();
    const lastShown = localStorage.getItem("betaModalDate");
    if (lastShown !== today) {
      setShowBetaModal(true);
    }

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // 👇 Scroll to section if redirected with state
  useEffect(() => {
    if (location.state?.scrollTo) {
      const id = location.state.scrollTo;
      const el = document.getElementById(id);
      if (el) {
        const headerHeight =
          document.querySelector(".main-header")?.offsetHeight || 80;
        const top =
          el.getBoundingClientRect().top + window.pageYOffset - headerHeight;
        window.scrollTo({ top, behavior: "smooth" });
      }
    }
  }, [location.state]);

  const handleModalClose = () => {
    setShowBetaModal(false);
    const today = new Date().toLocaleDateString();
    localStorage.setItem("betaModalDate", today);
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <>
      <Header />

      {/* home */}
      <section id="home">
        <TopComponent />
      </section>

      {/* features */}
      <section id="features">
        <FeaturesComponent />
      </section>

      {/* <section>
        <DailySchedule />
      </section> */}

      {/* screen shots */}
      {/* <section id="screenshots">
        <ScreenshotSlider />
      </section> */}

      <div className="screenshot-section wapper">
        <div className="silder-part">
          <h2>Join Our Beta Program</h2>
          <div className="join-beta-wrapper">
            <button
              className="join-beta-btn"
              onClick={() => setShowBetaModal(true)}
            >
              Join Beta Program
            </button>
          </div>
        </div>
      </div>

      {/* contact */}
      <section id="contact">
        <ContactForm />
      </section>
      <Footer />

      <button
        className={`back-to-top ${showScrollTop ? "show" : ""}`}
        onClick={scrollToTop}
        aria-label="Scroll to top"
      >
        ↑
      </button>

      {showBetaModal && <BetaTesterModal onClose={handleModalClose} />}
    </>
  );
};

export default Home;
